import cloudinary from '../../../helpers/cloudinary';
import picturefill from 'picturefill';
import styles from './picture-fill.module.scss';

export type PictureRetinaProps = {
  class?: string;
  className?: string;
  cloudinaryFilters: string;
  imgStyle?: any;
  placeholder?: string;
  url: string | any;
  alt?: string;
  // userInitials prop has higher priority than the image and the placeholder
  userInitials?: string;
};

type State = {
  isImageLoaded: boolean;
};

const defaultProps: PictureRetinaProps = {
  cloudinaryFilters: '',
  imgStyle: {},
  url: '',
  alt: '',
};

export default class PictureRetina extends React.Component<
  PictureRetinaProps,
  State
> {
  static defaultProps = defaultProps;
  static displayName = 'PictureRetina';
  constructor(props: PictureRetinaProps) {
    super(props);
    this.state = {
      isImageLoaded: !this.props.placeholder,
    };
  }

  componentDidMount() {
    picturefill();
  }

  handleLoad() {
    if (!this.state.isImageLoaded) {
      this.setState({ isImageLoaded: true });
    }
  }

  renderImage() {
    const { url, cloudinaryFilters, imgStyle, alt, className } = this.props;
    return (
      <img
        srcSet={`${cloudinary(url, cloudinaryFilters)} 1x, ${cloudinary(
          url,
          cloudinaryFilters + ',dpr_2.0',
        )} 2x`}
        src={cloudinary(url, cloudinaryFilters)}
        className={className ? styles[className] : this.props.class}
        onLoad={() => this.handleLoad()}
        style={{
          ...imgStyle,
          ...(!this.state.isImageLoaded ? { width: 0, height: 0 } : {}),
        }}
        alt={alt}
      />
    );
  }

  renderInitials(initials: string) {
    const { className } = this.props;

    return (
      <abbr className={className ? styles[className] : this.props.class}>
        {initials}
      </abbr>
    );
  }

  render() {
    const { placeholder, imgStyle, alt, userInitials } = this.props;
    const className = this.props.className ?? (this.props.class || '');

    if (userInitials) {
      return this.renderInitials(userInitials);
    }

    if (!placeholder) {
      return this.renderImage();
    }
    return (
      <span style={{ width: '100%' }}>
        {!this.state.isImageLoaded && (
          <img
            className={this.props.className ? styles[className] : className}
            src={
              placeholder === 'circle'
                ? require(`../placeholders/circle.png`)
                : placeholder
            }
            style={{ ...imgStyle }}
            alt={alt}
          />
        )}
        {this.renderImage()}
      </span>
    );
  }
}
